import React from 'react';
import styles from './styles.module.scss';

export const DocumentList = ({ children }) => (
  <div className={styles.documentList}>
    {children}
  </div>
);
